export default __webpack_public_path__ + "static/media/open-modal--dark.f75b4a5e.svg";